/**
 * We must use the 'object' type in this file to align with Eppo's JS SDK,
 * which returns 'object' for getJSONAssignment.
 */
/* eslint-disable @typescript-eslint/ban-types */

import { AttributeType } from '@eppo/js-client-sdk';

export const InitializationStates = {
  UNINITIALIZED: 'uninitialized',
  INITIALIZING: 'initializing',
  INITIALIZED: 'initialized',
  BYPASSED: 'bypassed',
} as const;

export type InitializationState = typeof InitializationStates[keyof typeof InitializationStates];

export type SubjectAttributes = Record<string, AttributeType>;

// subjectKeyTypes that may be used to bucket subjects. This is not an exhaustive list and can be added to as needed.
export const SubjectKeyTypes = {
  CUID: 'cuid',
  VUID: 'vuid',
  DEVICE_ID: 'device_id',
  TEAM_OWNER_ID: 'team_owner_id',
  CLIP_ID: 'clip_id',
  TOGGLE_FOR_ALL_SUBJECTS: 'toggle_for_all_subjects',
} as const;

export type SubjectKeyType = typeof SubjectKeyTypes[keyof typeof SubjectKeyTypes];

export type Subject = {
  key: string | number;
  keyType: SubjectKeyType;
  additionalData?: Record<string, AttributeType>;
};

export const VariationTypes = {
  STRING: 'STRING',
  NUMERIC: 'NUMERIC',
  INTEGER: 'INTEGER',
  BOOLEAN: 'BOOLEAN',
  JSON: 'JSON',
} as const;

export type VariationType = typeof VariationTypes[keyof typeof VariationTypes];

export type VariationValue = string | number | boolean | object;

export type VariationValueTypeMap = {
  STRING: string;
  NUMERIC: number;
  INTEGER: number;
  BOOLEAN: boolean;
  JSON: object;
};
export type VariationValueForType<T extends VariationType> = VariationValueTypeMap[T];
